"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceOrigin_1 = require("../model/PriceOrigin");

var PriceWithVat_1 = require("../model/PriceWithVat");

var PriceWithVatConverter_1 = require("./PriceWithVatConverter");
/**
 * Implementation of {@link PriceWithVatConverter}.
 *
 * @author Jan Prokop
 */


var PriceWithVatConverterImpl =
/*#__PURE__*/
function (_PriceWithVatConverte) {
  _inherits(PriceWithVatConverterImpl, _PriceWithVatConverte);

  function PriceWithVatConverterImpl() {
    _classCallCheck(this, PriceWithVatConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceWithVatConverterImpl).apply(this, arguments));
  }

  _createClass(PriceWithVatConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceWithVat_1.PriceWithVat(conversions.asObject(source, 'value', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'vatValue', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asEnumOpt(source.origin, PriceOrigin_1.PriceOrigin));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: conversions.fromBigNumber(source.value),
        vatValue: conversions.asObjectOpt(source, 'vatValue', function (v) {
          return conversions.fromBigNumber(v);
        }),
        origin: source.origin ? source.origin : null
      });
      return result;
    }
  }]);

  return PriceWithVatConverterImpl;
}(PriceWithVatConverter_1.PriceWithVatConverter);

exports.PriceWithVatConverterImpl = PriceWithVatConverterImpl;